/* eslint-disable @typescript-eslint/camelcase */
import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import Modal from '../../../components/Modal'
import Private from '../../../components/Private'
import RealtyProposals from '../../../components/Realty/Proposal'
import Text from '../../../components/Text'
import { REALTY_OPTION_TYPE } from '../../../config/realty-types'
import routes from '../../../config/routes'
import RealtyEditForm from '../../../forms/Realty/Edit'
import AccountForm from '../../../forms/UserData'
import { currencyFormat } from '../../../utils/form-validations'
import { Actions, ModalContent } from '../Create/styles'

interface Props {

}

const RealtyEditScreen: React.FC<Props> = () => {
  const history = useHistory()
  const { request } = useRequest()
  const { request: requestProposal, loading } = useRequest()
  const params = useParams<{ id: string }>()

  const [step, setStep] = useState<number>(3)
  const [realtyTypes, setRealtyTypes] = useState<REALTY_OPTION_TYPE[]>([])
  const [realty, setRealty] = useState<any | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { token, user, setUser } = useAuth()

  const needUser = () =>{
    let resp = false
    const fields = ['birth_year',
      'city',
      'cpf',
      'email',
      'name',
      'phone',
    ]
    fields.forEach(field => {
      if (user[field] === null || user[field] === '')
        resp = true
    })
    return resp

  }

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realty_types`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      if (mounted) {
        const types: REALTY_OPTION_TYPE[] = []

        data.data.data.forEach((item: any) => {
          types.push({ label: item.type, value: item.id })
        })

        setRealtyTypes(types)
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  const reload = () => {
    const mounted = true
    setIsLoading(true)
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realties/${params.id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      if (mounted) {
        setIsLoading(false)
        setRealty({...data.data.data, accept_terms_conditions: user.accept_terms_conditions,
          accept_privacy_policy: user.accept_privacy_policy})
      }
    })
  }

  useEffect(() => {
    let mounted = true
    setIsLoading(true)
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realties/${params.id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      if (mounted) {
        setIsLoading(false)
        setRealty({...data.data.data, accept_terms_conditions: user.accept_terms_conditions,
          accept_privacy_policy: user.accept_privacy_policy})
      }
    })
    return () => {
      mounted = false
    }
  }, [])
  if (isLoading) {
    return (<Loader
      full
      delay={0}
    />)
  }

  return (
    <>
      <Private>
        <div>
          <div
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Text
              tag="h1"
            >
              Editar imóvel
            </Text>
            <Button
              style={{ marginLeft: 'auto' }}
              label="Listar imóvel"
              backgroundColor="darkBlue"
              fontColor="white"
              borderColor="lightGray"
              small
              onClick={() => {
                history.push(routes.realty.index.path)
              }}
            />
          </div>
          {/* {needUser() ? (<>
            <AccountForm
              initialValues={user}
            />
          </>) : ''} */}
          <div >
            <Text
              style={{ maxWidth: '50%' }}
              tag="h2"
            >
              Dados do imóvel
            </Text>
            <Text
              tag="h2"
              color="darkGray"
            >
              Tem interesse em vender o imóvel?
            </Text>

            <Actions>
              <Button
                label="SIM"
                backgroundColor={realty?.wants_to_sell === 1 ? 'blue' : 'white'}
                fontColor={realty?.wants_to_sell === 1 ? 'white' : 'darkGray'}
                borderColor={realty?.wants_to_sell === 1 ? 'blue' : 'lightGray'}
                onClick={() => {
                  setRealty({ ...realty, wants_to_sell: 1 })
                  if (!realty.type_id) {
                    if (step < 2)
                      setStep(2)
                  }
                  else
                    setStep(3)
                }}
                block
              />

              <Button
                label="NÃO"
                backgroundColor={realty?.wants_to_sell === false ? 'blue' : 'white'}
                fontColor={realty?.wants_to_sell === false ? 'white' : 'darkGray'}
                borderColor={realty?.wants_to_sell === false ? 'blue' : 'lightGray'}
                onClick={() => {
                  setRealty({ ...realty, wants_to_sell: 0 })
                  setStep(1)
                }}
                block
              />
            </Actions>

            <p
              style={
                {fontFamily: 'Roboto',
                  fontSize: '16px',
                  lineHeight: '19px',
                  textAlign: 'left',
                  color: '#606060'}
              }
            >
              A plataforma IPTU.APP não serve para a consulta de débitos de imposto, emissão de guia amarela ou qualquer assunto relacionado à renegociação de débitos. Em caso de dúvidas acesse o <a
                href="https://cdn.iptu.app/assets/docs/manual-usuario-iptu.pdf"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
              >MANUAL DO USUÁRIO</a>
            </p>
          </div>
          <div
            hidden={step < 2 }
          >
            <Text
              tag="h2"
              color="darkGray"
            >
              Selecione o tipo
            </Text>
            {realtyTypes.map((type: REALTY_OPTION_TYPE, index) => {
              return (
                <Button
                  key={`buttons_${index}`}
                  style={{ margin: '10px' }}
                  label={type.label}
                  backgroundColor={type.value === realty?.type_id ? 'blue' : 'white'}
                  fontColor={type.value === realty?.type_id ? 'white' : 'darkGray'}
                  borderColor={type.value === realty?.type_id ? 'blue' : 'lightGray'}
                  onClick={() => {
                    setRealty({ ...realty, type: type.label, type_id: type.value })
                    setStep(3)
                  }}
                />
              )
            })}
          </div>
          <div
            hidden={step < 3 }
          >
            {realty?.wants_to_sell === undefined ? (
              <div></div>
            ) : realty?.wants_to_sell === 1 ? (
              <>
                <Text
                  tag="h2"
                  color="darkGray"
                >
                  Detalhes
                </Text>
                <RealtyEditForm
                  initialValues={realty}
                  onSubmit={() => {
                    history.push(routes.realty.index.path+'?created=true')
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }}
                />
                <Button
                  label="DELETAR IMÓVEL"
                  block
                  backgroundColor="red"
                  onClick={() => request({
                    method: 'DELETE',
                    url: `${process.env.REACT_APP_API_URL}/realties/${params.id}`,
                  }).then(() => {
                    toast.success('Imóvel deletado com sucesso')
                    setUser!({ ...user, realties_count: user.realties_count - 1 })
                    history.push(routes.realty.index.path)
                  }).catch((error) => {
                    if(error.response.data.message)
                      toast.error(error.response.data.message)
                    else
                      toast.error('Ocorreu um erro ao deletar imóvel')
                  })}
                />
                <div
                  style={{
                    margin: '30px 0',
                  }}
                >
                  <RealtyProposals
                    realty={realty}
                  />
                </div>

                {realty.status === 'proposal' && realty.proposal_amount && (
                  <div
                    style={{
                      border: '1px solid #ececec',
                      margin: '30px 0',
                      padding: 20,
                    }}
                  >
                    <p>
                      Aceitar proposta de
                      {' '}
                      <strong>
                        R$ {currencyFormat(realty.proposal_amount)}
                      </strong>
                    ?
                    </p>
                    <Button
                      label="Aceitar"
                      backgroundColor="green"
                      disabled={loading}
                      onClick={() => {
                        handleFormSubmit({
                          request: requestProposal({
                            method: 'put',
                            url: `${process.env.REACT_APP_API_URL}/proposals/${realty.proposal_id}`,
                            data: { status: 'approved' },
                          }),
                          onFailure(err) {
                            toast.error('Erro ao aceitar proposta')
                          },
                          onSuccess() {
                            toast.success('Proposta aceita com sucesso')
                            reload()
                          },
                          onValidationErrors() {
                            toast.error('Erro de validação')
                          },
                        })
                      }}
                    />
                    {' '}
                    <Button
                      label="Recusar"
                      backgroundColor="red"
                      disabled={loading}
                      onClick={() => {
                        handleFormSubmit({
                          request: requestProposal({
                            method: 'put',
                            url: `${process.env.REACT_APP_API_URL}/proposals/${realty.proposal_id}`,
                            data: { status: 'rejected' },
                          }),
                          onFailure(err) {
                            toast.error('Erro ao recusar proposta')
                          },
                          onSuccess() {
                            toast.success('Proposta recusada com sucesso')
                            reload()
                          },
                          onValidationErrors() {
                            toast.error('Erro de validação')
                          },
                        })
                      }}
                    />
                  </div>
                )}

                {realty.status === 'approved' && realty.proposal_amount && (
                  <div
                    style={{
                      border: '1px solid #ececec',
                      margin: '30px 0',
                      padding: 20,
                    }}
                  >
                    <p>
                      Você aceitou a proposta de
                      {' '}
                      <strong>
                        R$ {currencyFormat(realty.proposal_amount)}
                      </strong>
                    </p>
                  </div>
                )}

              </>
            ) : (
              <Modal
                open
                small
                onToggle={() => {
                  setRealty({ ...realty, wants_to_sell: undefined })
                }}
              >
                <ModalContent>
                  <Text
                    tag="h2"
                    align="center"
                  >
                        CADASTRO DE IMÓVEL NEGADO
                  </Text>

                  <Text
                    tag="p"
                    color="darkGray"
                  >
                         Recebemos a informação de que não possui interesse em cadastrar imóvel para venda.
                        Atualmente a plataforma IPTU.APP tem o objetivo de viabilizar compra de imóveis com dívida ativa. Caso
                        tenha interesse em vender seu imóvel, por favor, realize o cadastro e entre em contato conosco.
                  </Text>

                  <Button
                    label="ENTENDI"
                    onClick={() => {
                      setRealty({ ...realty, wants_to_sell: undefined })
                    }}
                  />
                </ModalContent>
              </Modal>
            )}
          </div>

        </div>
      </Private>
    </>
  )
}

export default RealtyEditScreen
